import { GridCellProps, GridFilterCellProps, GridFooterCellProps, GridHeaderCellProps } from '@progress/kendo-react-grid'
import { MenuRouteDto } from '@v1UsersApi'
import { ComponentType, ReactElement } from 'react'

export enum DcsPermissions {
    AddRole = 1,
    EditRole = 2,
    DeleteRole = 3,
    AddPermission = 4,
    EditPermission = 5,
    DeletePermission = 6,
    AddDcsUser = 7,
    EditDcsUser = 8,
    DeleteDcsUser = 9,
    AddPermissionToUser = 10,
    EditRolePermissionTemplate = 11,
    EditTabOrderForUser = 12,
    AddTask = 13,
    EditTask = 14,
    EditRoleTabTemplate = 15,
    ViewOthersTasks = 16,
    AddCase = 17,
    EditCase = 18,
    AddCaseView = 19,
    EditCaseView = 20,
    AddDealerView = 22,
    EditDealerView = 23,
    AddDealerContact = 24,
    EditDealerContact = 25,
    AddDealer = 26,
    EditDealer = 27,
    AddNote = 28,
    EditNote = 29,
    AddTaskReminder = 30,
    EditTaskReminder = 31,
    AddCaseDomain = 32,
    EditCaseDomain = 33,
    AddDevelopmentView = 34,
    EditDevelopmentView = 35,
    AddDevelopment = 38,
    EditDevelopment = 39,
    AddDealerGroup = 42,
    EditDealerGroup = 43,
    AddLeadView = 44,
    EditLeadView = 45,
    AddLead = 46,
    EditLead = 47,
    AddAttachment = 48,
    EditAttachment = 49,
    AddAttachmentCase = 50,
    EditAttachmentCase = 51,
    AddAttachmentDealer = 52,
    EditAttachmentDealer = 53,
    AddAttachmentLead = 54,
    EditAttachmentLead = 55,
    AddAttachmentTask = 56,
    EditAttachmentTask = 57,
    AddAttachmentUser = 58,
    EditAttachmentUser = 59,
    AddNoteCase = 60,
    EditNoteCase = 61,
    AddNoteDealer = 62,
    EditNoteDealer = 63,
    AddNoteDevelopment = 66,
    EditNoteDevelopment = 67,
    AddNoteLead = 68,
    EditNoteLead = 69,
    AddNoteTask = 70,
    EditNoteTask = 71,
    SignUpDealer = 72,
    EditSignUpDealer = 73,
    ConvertJoinNowToDealer = 74,
    CancelDealer = 75,
    CancelRequestDealer = 76,
    MarkNotPastDue = 77,
    ChangePrimaryProduct = 78,
    SaveDealer = 79,
    EditSavedByDealer = 80,
    AddComponent = 81,
    EditComponent = 82,
    EditCallHistory = 83,
    ViewAllCallHistoryLead = 84,
    ViewLeadHistory = 85,
    ViewAllNotesLead = 86,
    AssignLeadToOthers = 87,
    ViewSalesPersonForDealer = 88,
    AddNews = 89,
    EditNews = 90,
    DeleteNews = 91,
    AddTestimonial = 92,
    EditTestimonial = 93,
    DeleteTestimonial = 94,
    AddSalesScript = 95,
    EditSalesScript = 96,
    DeleteSalesScript = 97,
    AddFranchiseScript = 98,
    EditFranchiseScript = 99,
    DeleteFranchiseScript = 100,
    AddCustomerServiceScript = 101,
    EditCustomerServiceScript = 102,
    DeleteCustomerServiceScript = 103,
    AddSaveScript = 104,
    EditSaveScript = 105,
    DeleteSaveScript = 106,
    AddNotification = 107,
    EditNotification = 108,
    DeleteNotification = 109,
    AddBlog = 110,
    EditBlog = 111,
    DeleteBlog = 112,
    ViewMyDealer = 113,
    SignUpAsOtherSalesperson = 114,
    ViewOwnerForLead = 115,
    AddImporter = 116,
    EditImporter = 117,
    DeleteLead = 118,
    DeleteOwnManualLead = 119,
    ViewProductRevenueReport = 120,
    AddSalespeople = 121,
    EditSalespeople = 122,
    AddExporter = 123,
    EditExporter = 124,
    AddDomainAccess = 1121,
    EditDomainAccess = 1122,
    AddRegistrar = 1123,
    EditRegistrar = 1124,
    ViewRevenueByRepReport = 1125,
    ViewAllCalls = 1126,
    ViewMyProfileTab = 1127,
    ViewHomeTab = 1128,
    ViewDealersTab = 1129,
    ViewCasesTab = 1130,
    ViewLeadsTab = 1131,
    ViewCallsTab = 1132,
    ViewExportersTab = 1133,
    ViewImportersTab = 1134,
    ViewDomainsTab = 1135,
    ViewUsersTab = 1136,
    ViewCustomerServiceTrainingTab = 1137,
    ViewDealerGroupsTab = 1138,
    ViewDeleteInventoryTab = 1139,
    ViewDmsIntegrationTab = 1140,
    ViewRateSheetTab = 1141,
    ViewReportsTab = 1142,
    ViewSalesTrainingTab = 1143,
    ViewScriptsTab = 1144,
    ViewTasksTab = 1145,
    ViewDcsSalesPeopleTab = 1146,
    ViewTestimonialsTab = 1147,
    ViewBlogTab = 1148,
    ViewRolesTab = 1149,
    ViewComponentsTab = 1150,
    ViewDevelopmentTab = 1151,
    ViewNotificationsTab = 1152,
    ViewPermissionsTab = 1153,
    ViewNewsTab = 1154,
    ViewOldExporterSystemTab = 1155,
    ViewNewExporterSystemTab = 1156,
    ViewAdfExporterSystemTab = 1157,
    AddDealerUser = 1158,
    EditDealerUser = 1159,
    DeleteDealerUser = 1160,
    DeleteDealer = 1161,
    ReactivateDealerJoinNow = 2158,
    ViewRevenueByPackageReport = 2159,
    ViewAllPendingDealers = 2160,
    DeleteDomain = 3158,
    AddNoteImporter = 3159,
    EditNoteImporter = 3160,
    AddNoteExporter = 3161,
    EditNoteExporter = 3162,
    AddNoteDealerContact = 3163,
    EditNoteDealerContact = 3164,
    AddAttachmentImporter = 3166,
    EditAttachmentImporter = 3167,
    AddAttachmentExporter = 3168,
    EditAttachmentExporter = 3169,
    ViewDeletedDealers = 3170,
    EditDealerBillingDate = 3171,
    DeleteNonPaymentDealer = 3172,
    OutsideCollectionsDealer = 3173,
    EditUserCallHistory = 3174,
    EditOwnerDealer = 3175,
    DeletePendingDealer = 3176,
    ViewDealerLongevityByRepReport = 3177,
    ViewRevenueByMonthReport = 3178,
    ChangeAddOnProducts = 3179,
    DeleteCase = 3180,

    AddWebsite = 3181,
    EditWebsite = 3182,
    DeleteWebsite = 3183,
    AddWebsiteDomain = 3184,
    EditWebsiteDomain = 3185,
    DeleteWebsiteDomain = 3186,
    AddWebsitePage = 3187,
    EditWebsitePage = 3188,
    DeleteWebsitePage = 3189,
    AddWebsitePageModule = 3190,
    EditWebsitePageModule = 3191,
    DeleteWebsitePageModule = 3192,
    AddWebsitePageModuleSetting = 3193,
    EditWebsitePageModuleSetting = 3194,
    DeleteWebsitePageModuleSetting = 3195,

    AddWebsiteTemplate = 3196,
    EditWebsiteTemplate = 3197,
    DeleteWebsiteTemplate = 3198,
    AddWebsiteTemplatePage = 3199,
    EditWebsiteTemplatePage = 3200,
    DeleteWebsiteTemplatePage = 3201,
    AddWebsiteTemplatePageModule = 3202,
    EditWebsiteTemplatePageModule = 3203,
    DeleteWebsiteTemplatePageModule = 3204,

    AddContainer = 3205,
    EditContainer = 3206,
    DeleteContainer = 3207,
    AddModule = 3208,
    EditModule = 3209,
    DeleteModule = 3210,
    AddModuleCategory = 3211,
    EditModuleCategory = 3212,
    DeleteModuleCategory = 3213,
    AddModuleSetting = 3214,
    EditModuleSetting = 3215,
    DeleteModuleSetting = 3216,
    AddPane = 3217,
    EditPane = 3218,
    DeletePane = 3219,
    AddSettingType = 3220,
    EditSettingType = 3221,
    DeleteSettingType = 3222,
    AddWebsiteStyle = 3223,
    EditWebsiteStyle = 3224,
    DeleteWebsiteStyle = 3225,
    AddWebsiteStylePage = 3226,
    EditWebsiteStylePage = 3227,
    DeleteWebsiteStylePage = 3228,
    AddRoute = 3229,
    EditRoute = 3230,
    DeleteRoute = 3231,
    AddModuleSettingValue = 3232,
    EditModuleSettingValue = 3233,
    DeleteModuleSettingValue = 3234,
    AddWebsiteModule = 3235,
    EditWebsiteModule = 3236,
    DeleteWebsiteModule = 3237,
    AddWebsiteModuleSetting = 3238,
    EditWebsiteModuleSetting = 3239,
    DeleteWebsiteModuleSetting = 3240,
    AddWebsiteTemplateModule = 3241,
    EditWebsiteTemplateModule = 3242,
    DeleteWebsiteTemplateModule = 3243,
    AddWebsiteSetting = 3244,
    EditWebsiteSetting = 3245,
    DeleteWebsiteSetting = 3246,
    ResetWebsiteCache = 3247,
    ResetWebsitePageCache = 3248,
    ResetWebsitePageModuleCache = 3249,
    CacheAdmin = 3250,
    AddWebsiteTemplatePageModuleSetting = 3251,
    EditWebsiteTemplatePageModuleSetting = 3252,
    DeleteWebsiteTemplatePageModuleSetting = 3253,
    AddWebsiteTemplateModuleSetting = 3254,
    EditWebsiteTemplateModuleSetting = 3255,
    DeleteWebsiteTemplateModuleSetting = 3256,
    EditDealerCreatedDate = 3257,
    AddDcsUserTrainingVacation = 3258,
    EditDcsUserTrainingVacation = 3259,
    DeleteDcsUserTrainingVacation = 3260,
    ConvertWebsiteToTemplate = 3261,
    EditBulkImportKeys = 3262,
    EditBulkInventory = 3263,
    ViewFormsTab = 3264,
    ReactivateDealer = 3265,
    AddInvoice = 3266,
    EditInvoice = 3267,
    VoidInvoice = 3268,
    AddInvoicePayment = 3269,
    EditInvoicePayment = 3270,
    VoidInvoicePayment = 3271,
    AddInvoiceDiscountRecurring = 3272,
    EditInvoiceDiscountRecurring = 3273,
    DeleteInvoiceDiscountRecurring = 3274,
    AddInvoiceDiscountOneTime = 3275,
    EditInvoiceDiscountOneTime = 3276,
    DeleteInvoiceDiscountOneTime = 3277,
    AddInvoiceItem = 3278,
    EditInvoiceItem = 3279,
    DeleteInvoiceItem = 3280,
    AddDealerToken = 3281,
    EditDealerToken = 3282,
    DeleteDealerToken = 3283,
    ICheckAddInvoice = 3284,
    ICheckDeleteCheckToken = 3285,
    ICheckDeleteCreditCardToken = 3286,
    ICheckDeleteInvoice = 3287,
    ICheckProcessCheck = 3288,
    ICheckProcessCheckToken = 3289,
    ICheckProcessCreditCard = 3290,
    ICheckProcessCreditCardToken = 3291,
    ICheckPullReturnedChecks = 3292,
    ICheckSaveCheckToken = 3293,
    ICheckUpdateCheckToken = 3294,
    ICheckSaveCreditCardToken = 3295,
    ICheckUpdateCreditCardToken = 3296,
    ICheckVerifyCheck = 3297,
    ICheckVoidTransaction = 3298,
    ICheckPullTransactionReport = 3299,
    AddDealerCredit = 3300,
    EditDealerCredit = 3301,
    DeleteDealerCredit = 3302,
    ViewAccountingTab = 3304,
    AddUserVacationRequest = 3305,
    EditUserVacationRequest = 3306,
    DeleteUserVacationRequest = 3307,
    ApproveUserVacationRequest = 3308,
    AddDealerMasterBilling = 3309,
    EditDealerMasterBilling = 3310,
    DeleteDealerMasterBilling = 3311,
    AddDealerMasterBillingDealer = 3312,
    EditDealerMasterBillingDealer = 3313,
    DeleteDealerMasterBillingDealer = 3314,
    AddExistingCustomerScript = 3315,
    EditExistingCustomerScript = 3316,
    DeleteExistingCustomerScript = 3317,
    CheckGetExpiringCards = 3318,
    AddQuote = 3319,
    EditQuote = 3320,
    DeleteQuote = 3321,
    AddObjectionScript = 3322,
    EditObjectionScript = 3323,
    DeleteObjectionScript = 3324,
    SendEchoSignDocument = 3325,
    SendEchoSignDocumentReminder = 3326,
    CancelEchoSignDocument = 3327,
    ViewAllDealers = 3328,
    ViewCommissionScheduleTab = 3329,
    ViewBonusPlanTab = 3330,
    ViewLacBonusPlanTab = 3331,
    AddTextingScript = 3332,
    EditTextingScript = 3333,
    DeleteTextingScript = 3334,
    ViewTextingProductRevenueReport = 3335,
    ViewBusinessUnitRevenueReport = 3336,
    SendAccountingCcAuthorizationRecurring = 3337,
    SendAccountingCcHasExpired = 3338,
    SendAccountingWebsiteDisconnection = 3339,
    SendTextingInitialAchRecurringByMail = 3340,
    SendTextingInitialCcRecurringByMail = 3341,
    AddLacOnlyDealerToVast = 3342,
    DeleteLacOnlyDealerToVast = 3343,
    EditForms = 3344,
    AddPendingDiscount = 3345,
    EditPendingDiscount = 3346,
    DeletePendingDiscount = 3347,
    ConvertPendingDiscount = 3349,
    ViewSaveScript = 3348,
    ViewClCreditCard = 3350,
    ChangeClCreditCard = 3351,
    DeleteClCreditCard = 3352,
    AddClCreditCard = 3353,
    ViewDefaultClSettings = 3354,
    ChangeDefaultClSettings = 3355,
    ViewClTemplate = 3356,
    ChangeClTemplate = 3357,
    AddClTemplate = 3358,
    DeleteClTemplate = 3359,
    ViewClPostingCity = 3360,
    ChangeClPostingCity = 3361,
    AddClPostingCity = 3362,
    DeleteClPostingCity = 3363,
    ViewClContact = 3364,
    ChangeClContact = 3365,
    AddClContact = 3366,
    DeleteClContact = 3367,
    ViewClLocation = 3368,
    ChangeClLocation = 3369,
    AddClLocation = 3370,
    DeleteClLocation = 3371,
    ViewClMapLocation = 3372,
    ChangeClMapLocation = 3373,
    AddClMapLocation = 3374,
    DeleteClMapLocation = 3375,
    ViewClPostingHistory = 3376,
    ChangeClPostDefault = 3377,
    CanPostClAds = 3378,
    ChangeClAds = 3379,
    DeleteClAds = 3380,
    ViewUsersLogins = 4329,
    IssueRefund = 4330,
    SignUpLacDealer = 4331,
    EditSignUpLacDealer = 4332,
    SendEchoSignDocumentDjn = 4333,
    ViewCommissionReport = 4334,
    ViewBatchReport = 4335,
    ViewDealersByProductReport = 4336,
    ViewAccountingReports = 4337,
    SendEchoSignLacach = 4338,
    SendEchoSignLaccc = 4339,
    SendEchoSign12MonthExisting = 4340,
    SendEchoSign12MonthNew = 4341,
    SendEchoSignAchInitialRecurring = 4342,
    SendEchoSignAchOneTime = 4343,
    SendEchoSignAchRecurring = 4344,
    SendEchoSignCcAuth = 4345,
    SendEchoSignDomainTransfer = 4346,
    SendEchoSignLac12Month = 4347,
    EditImportJob = 4348,
    SendExistingDealerQuote = 4349,
    ViewLacProductRevenueReport = 4350,
    AddLacExistingCustomerScript = 4351,
    EditLacExistingCustomerScript = 4352,
    DeleteLacExistingCustomerScript = 4353,
    AddLacNewCustomerScript = 4355,
    EditLacNewCustomerScript = 4356,
    DeleteLacNewCustomerScript = 4357,
    SendEchoSignLacccOneTime = 4358,
    SendEchoSignLacachOneTime = 4359,
    AddChargeback = 4360,
    ViewLacLeads = 4361,
    AddAdfLeadImport = 4362,
    EditAdfLeadImport = 4363,
    DeleteAdfLeadImport = 4364,
    SendEchoSignLacOnlyAch = 4365,
    SendEchoSignLacOnlyAchOneTime = 4366,
    SendEchoSignLacOnlyCc = 4367,
    SendEchoSignLacOnlyCcOneTime = 4368,
    MarkUserVacationAsUnPaid = 4369,
    AddSmsNumber = 4370,
    EditSmsNumber = 4371,
    AddPendingProduct = 4372,
    EditPendingProduct = 4373,
    DeletePendingProduct = 4374,
    SendCoBranded12MonthContract = 4375,
    SendCoBrandedExistingAch = 4376,
    SendCoBrandedNewAch = 4377,
    SendCoBrandedExistingCc = 4378,
    SendCoBrandedNewCc = 4379,
    AddLacRebuttalScript = 4380,
    EditLacRebuttalScript = 4381,
    DeleteLacRebuttalScript = 4382,
    ViewEchosignDoc = 4383,
    SendLacGrandfatheredRate = 4384,
    ViewCustomWebsiteRevenueReport = 4385,
    ViewAllRevenueReport = 4386,
    AddDealerProduct = 4387,
    EditDealerProduct = 4388,
    ChangeDealerProductStatus = 4389,
    ChangeDealerProductStatusFromPending = 4390,
    ChangeDealerProductStatusToSaved = 4391,
    ChangeDealerProductOwner = 4392,
    ChangeDealerProductCreatedDate = 4393,
    ChangeDealerProductStatusToDeleted = 4394,
    ChangeDealerProductContractEndDate = 4395,
    ViewLacLeadsReport = 4396,
    AddCarGurusExclusion = 4397,
    DeleteCarGurusExclusion = 4398,
    ViewAlexaSiteMetricsReport = 4399,
    //DCS
    DcsChangeDealer = 4400,
    ChangeDealersInAGroup = 4426,
    //Inventory
    AddInventory = 4401,
    EditInventory = 4402,
    DeleteInventory = 4403,
    SellInventory = 4404,
    AddInventoryPhotos = 4405,
    EditInventoryPhotos = 4406,
    DeleteInventoryPhotos = 4407,
    EditInventoryPrice = 4408,
    EditInventoryCost = 4409,
    AddInventoryAdditionalCost = 4410,
    EditInventoryAdditionalCost = 4411,
    DeleteInventoryAdditionalCost = 4412,
    ReactivateInventory = 4425,
    ViewInventoryCost = 4562,
    ViewInventoryProfit = 5386,
    EditInventoryStockNumber = 4563,
    EditInventoryVin = 4564,
    EditInventoryWebsiteDisplayOptions = 4565,
    EditInventoryHighlight = 4566,
    EditInventoryConditionReport = 4567,
    EditInventoryWarranty = 4568,
    EditInventoryPurchaseInformation = 4569,
    EditInventoryVideo = 4570,
    EditInventoryWindowSticker = 4571,
    EditInventoryBuyersGuide = 4572,
    EditInventoryPostToOve = 4573,
    AddCustomInventory = 4584,
    EditCustomInventory = 4585,
    DeleteCustomInventory = 4586,
    //Leads
    AddDcsLead = 4413,
    EditDcsLead = 4414,
    DeleteDcsLead = 4415,
    ViewCreditAppLeads = 4574,
    ViewContactUsLeads = 4575,
    ViewLocatorServiceLeads = 4576,
    ViewInquiryLeads = 4577,
    ViewSmsLeads = 4578,
    //Worksheet
    AddDcsWorksheet = 4416,
    EditDcsWorksheet = 4417,
    DeleteDcsWorksheet = 4418,
    //Deals
    AddDcsDeal = 4419,
    EditDcsDeal = 4420,
    DeleteDcsDeal = 4421,
    //Customers
    AddDcsCustomer = 4422,
    EditDcsCustomer = 4423,
    DeleteDcsCustomer = 4424,
    //Website Settings
    EditWebsiteAboutUs = 4427,
    EditWebsitePrivacyPolicy = 4428,
    EditWebsiteDefaultSellersNotes = 4429,
    EditWebsiteDealershipDisclaimer = 4430,
    AddDealerBlog = 4431,
    EditDealerBlog = 4432,
    DeleteDealerBlog = 4433,
    AddCustomerTestimonial = 4434,
    EditCustomerTestimonial = 4435,
    DeleteCustomerTestimonial = 4436,
    AddCoupon = 4437,
    EditCoupon = 4438,
    DeleteCoupon = 4439,
    AddPromotion = 4440,
    EditPromotion = 4441,
    DeletePromotion = 4442,
    EditWebsiteFuelEconomy = 4443,
    EditWebsiteHoursOfOperation = 4444,
    EditWebsiteInventorySpotlight = 4445,
    EditWebsiteNewArrivalPhoto = 4446,
    EditWebsiteSeoInformation = 4447,
    EditWebsiteSocialMedia = 4448,
    EditWebsiteVideoSpotlight = 4449,
    EditWebsiteInventoryModulePrice = 4450,
    AddDealerStaff = 4451,
    EditDealerStaff = 4452,
    DeleteDealerStaff = 4453,
    AddBuyer = 4454,
    EditBuyer = 4455,
    DeleteBuyer = 4456,
    EditAuctionSettings = 4458,
    EditBuyersOrderSettings = 4459,
    AddEmailNotification = 4460,
    EditEmailNotification = 4461,
    DeleteEmailNotification = 4462,
    AddCustomField = 4463,
    EditCustomField = 4464,
    DeleteCustomField = 4465,
    EditCustomFieldOrder = 4466,
    AddCustomTax = 4467,
    EditCustomTax = 4468,
    DeleteCustomTax = 4469,
    EditCustomTaxOrder = 4470,
    EditBuyHerePayHereSettings = 4471,
    EditDealershipInformation = 4472,
    AddDealerForm = 4473,
    EditDealerForm = 4474,
    DeleteDealerForm = 4475,
    EditDealerFormOrder = 4476,
    EditInventoryPreferences = 4477,
    AddDealerLeadSource = 4478,
    EditDealerLeadSource = 4479,
    DeleteDealerLeadSource = 4480,
    AddDealerLender = 4481,
    EditDealerLender = 4482,
    DeleteDealerLender = 4483,
    AddDealerLienHolder = 4484,
    EditDealerLienHolder = 4485,
    DeleteDealerLienHolder = 4486,
    AddDealerMobilePhone = 4487,
    EditDealerMobilePhone = 4488,
    DeleteDealerMobilePhone = 4489,
    EditReportingSettings = 4490,
    AddDealerVehicleCostCategory = 4491,
    EditDealerVehicleCostCategory = 4492,
    DeleteDealerVehicleCostCategory = 4493,
    EditVehicleHistoryReportSettings = 4494,
    AddDealerVehicleOption = 4495,
    EditDealerVehicleOption = 4496,
    DeleteDealerVehicleOption = 4497,
    AddDealerVendor = 4498,
    EditDealerVendor = 4499,
    DeleteDealerVendor = 4500,
    EditDealerDefaultVideoUrl = 4501,
    EditRoundRobin = 4502,
    ViewAccountsReceivableReport = 4503,
    ViewSalesByBuyerReport = 4504,
    ViewDcsMarketReport = 4509,
    ViewFeatureAdoptionReport = 4510,
    ViewAgeCostCurrentInventoryReport = 4511,
    ViewInventoryPerformanceReport = 4512,
    ViewInventoryAnalyticsReport = 4515,
    ViewInventoryReports = 4521,
    ViewSalesReports = 4522,
    ViewSalesByUpTypeReport = 4524,
    ViewSalesByAdvertisingSourceReport = 4525,
    ViewSalesByAdvertisingMediumReport = 4526,
    ViewSalesBySalesRepReport = 4527,
    ViewTaxesCollectedReport = 4528,
    ViewGrossByMonthReport = 4529,
    EditDefaultCouponSettings = 4532,
    AddImageToDcsImageLibrary = 4533,
    DeleteImageFromDcsImageLibrary = 4534,
    AddImageToDealerLibrary = 4535,
    DeleteImageFromDealerLibrary = 4536,
    AddImageToSelectedRotatingImages = 4537,
    DeleteImageFromSelectedRotatingImages = 4538,
    EditRotatingImages = 4539,
    AddSellersNoteTemplate = 4540,
    EditSellersNoteTemplate = 4541,
    DeleteSellersNoteTemplate = 4542,
    AddEmailCampaign = 4543,
    EditEmailCampaign = 4544,
    DeleteEmailCampaign = 4545,
    AddEmailTemplate = 4546,
    EditEmailTemplate = 4547,
    DeleteEmailTemplate = 4548,
    AddEmailTemplateForAllDealers = 4549,
    EditEmailTemplateForAllDealers = 4550,
    DeleteEmailTemplateForAllDealers = 4551,
    AddEmailContact = 4552,
    EditEmailContact = 4553,
    DeleteEmailContact = 4554,
    AddEmailContactList = 4555,
    EditEmailContactList = 4556,
    DeleteEmailContactList = 4557,
    EditDefaultPriceOrder = 4558,
    AddDealerPrice = 4559,
    EditDealerPrice = 4560,
    DeleteDealerPrice = 4561,
    ViewAllSmsConversations = 4579,
    ViewDcsCustomer = 4580,
    ViewDcsDeal = 4581,
    ViewDcsWorksheet = 4582,
    ViewDcsLead = 4583,
    AddDcsLeadNote = 4587,
    DeleteCallRecording = 4588,
    ViewEbayInventory = 4589,
    CanPostEbayAd = 4590,
    UpdateEbayAdStatus = 4591,
    CompleteEbayAdDraft = 4592,
    PublishEbayAd = 4593,
    RelistEbayAd = 4594,
    ChangeEbayAd = 4595,
    DeleteEbayAd = 4596,
    ViewEbayDefaultSetting = 4597,
    ChangeEbayDefaultSetting = 4598,
    ViewEbayTemplate = 4599,
    ChangeEbayTemplate = 4600,
    AddEbayTemplate = 4601,
    DeleteEbayTemplate = 4602,
    AddEbaySystemTemplate = 4603,
    ChangeEbaySystemTemplate = 4604,
    ViewEbayAuthToken = 4605,
    AddEbayAuthToken = 4606,
    DeleteEbayAuthToken = 4607,
    EditOtherSalesPeopleLeads = 4608,
    ViewGoogleAnalyticsSettings = 4609,
    EditGoogleAnalyticsSettings = 4610,
    ViewGoogleAnalyticsReports = 4611,
    AddGoogleAnalyticsReport = 4612,
    EditGoogleAnalyticsReport = 4613,
    DeleteGoogleAnalyticsReport = 4614,
    ViewGoogleAnalyicsLoginCredentials = 4615,
    AddTwilioCallTrackingNumber = 4616,
    EditTwilioCallTrackingNumber = 4617,
    EditGoogleAnalyticsLoginCredentials = 4618,
    DeleteOtherSalesPeopleLeads = 4619,
    AddReductionStrategy = 4620,
    EditReductionStrategy = 4621,
    DeleteReductionStrategy = 4622,
    EbayAdvancedMode = 4623,
    AddDealerAffliation = 5378,
    DeleteDealerAffiliation = 5379,
    ManageCraigslistCities = 5380,
    EditCraigslistDisclaimer = 5381,
    AddCraigslistPostingCredit = 5382,
    ManagePostingBlocks = 5383,
    ViewCraigslistQueue = 5384,
    EditEbayDraft = 6386,
    ViewTotalSalesAmount = 6416,
    ViewOtherSalesPeopleLeads = 6417,
    ViewDeals = 6418,
    ViewWorksheets = 6419,
    ViewLeads = 6420,
    ViewOtherSalesPeopleDeals = 6421,
    ViewOtherSalesPeopleWorksheets = 6422,
    ViewDealProfit = 6423,
    ViewWorksheetProfit = 6424,
    WholesaleBuyCars = 6425,
    ViewWebsiteSocialMedia = 6426,
    EditOtherSalesPeopleWorksheets = 6427,
    EditOtherSalesPeopleDeals = 6428,
    AddSendGridUser = 6429,
    ViewLogs = 6432,
    AddInventoryPayment = 6430,
    EditInventoryPayment = 6431,
    ViewBusinessSummaryReport = 6433,
    SignUpEvaluatorDealer = 6434,
    EditSignUpEvaluatorDealer = 6435,
    AddEditReputationManagementSettings = 6436,
    ViewAllByMonthReport = 6437,
    ViewAllByQuarterReport = 6438,
    ViewAllByRepReport = 6439,
    ViewAllByYearReport = 6440,
    ViewCancellationRequestsByDateReport = 6441,
    ViewCancellationRequestsByDatePerMonthReport = 6442,
    ViewCancellationRequestsByRepReport = 6443,
    ViewCancellationRequestsCountHistoryReport = 6444,
    ViewCancellationsByCompetitorReport = 6445,
    ViewCancellationsByDateReport = 6446,
    ViewCancellationsByDatePerMonthReport = 6447,
    ViewCancellationsByMonthReport = 6448,
    ViewCancellationsByProductReport = 6449,
    ViewCancellationsByRateReport = 6450,
    ViewCancellationsByReasonReport = 6451,
    ViewCancellationsByRepReport = 6452,
    ViewCancellationsOfPremiumFeaturesReport = 6453,
    ViewDailyRevenueGrowthReport = 6454,
    ViewDcslacSalesAndRevenueReport = 6455,
    ViewDealerFranchiseTypesReport = 6456,
    ViewDealerLongevityReport = 6457,
    ViewDealerLongevityHistoryReport = 6458,
    ViewDealersByContractReasonReport = 6459,
    ViewDealersInContractReport = 6460,
    ViewDealerStatusesReport = 6461,
    ViewLacAllByMonthReport = 6462,
    ViewLacAllByRepReport = 6463,
    ViewLacByRepReport = 6464,
    ViewLacCancelsByRepReport = 6465,
    ViewLacRevenueByRepActivatedReport = 6466,
    ViewLacSavesByRepReport = 6467,
    ViewLifetimeSalesReport = 6468,
    ViewNetGainByMonthReport = 6469,
    ViewNetGainByRepReport = 6470,
    ViewParkedByRepReport = 6471,
    ViewPastDueByRepReport = 6472,
    ViewPricingToolByRepReport = 6473,
    ViewProductsByLacRepReport = 6474,
    ViewProductsByRepReport = 6475,
    ViewProductsByTextingRepReport = 6476,
    ViewProductsSoldReport = 6477,
    ViewRateReductionReport = 6478,
    ViewReactivatesByMonthReport = 6479,
    ViewResponsivesByMonthReport = 6480,
    ViewResponsivesByRepReport = 6481,
    ViewRevenueAllByMonthReport = 6482,
    ViewRevenueByMonthLostReport = 6483,
    ViewRevenueByMonthRemainingReport = 6484,
    ViewRevenueByPackageJoinNowReport = 6485,
    ViewRevenueByRepActivatedReport = 6486,
    ViewRevenueByRepSoldReport = 6487,
    ViewRevenueByRetentionRepReport = 6488,
    ViewRevenueDcslacAllByMonthReport = 6489,
    ViewRevenueSoldCancelledReport = 6490,
    ViewRevenueSoldCancelledByMonthReport = 6491,
    ViewRevenueSoldCancelledByWeekReport = 6492,
    ViewRevenueSoldSavedCancelledReport = 6493,
    ViewRevenueSoldSavedCancelledByWeekReport = 6494,
    ViewRevenueSummaryReport = 6495,
    ViewSalesByDateReport = 6496,
    ViewSalesByMonthReport = 6497,
    ViewSalesByRepReport = 6498,
    ViewSalesFranchiseByMonthReport = 6499,
    ViewSalesFranchiseByRepReport = 6500,
    ViewSalesIndependentByRepReport = 6501,
    ViewSalesIndependentByMonthReport = 6502,
    ViewSalesIndependentFranchiseByMonthReport = 6503,
    ViewSalesIndependentFranchiseByRepReport = 6504,
    ViewSalesPersonOfTheMonthReport = 6505,
    ViewSalesPersonOfTheMonthSoldReport = 6506,
    ViewSalesRevenueActivatedByRepReport = 6507,
    ViewSalesSummaryReport = 6508,
    ViewSavesReport = 6509,
    ViewSavesByDiscountPercentReport = 6510,
    ViewSavesByMonthReport = 6511,
    ViewSavesByMonthRetentionReport = 6512,
    ViewSavesByRepReport = 6513,
    ViewSubscriberGrowthReport = 6514,
    ViewTextingAllByMonthReport = 6515,
    ViewTextingAllByRepReport = 6516,
    ViewTextingByRepReport = 6517,
    ViewTextingCancelsByRepReport = 6518,
    ViewTextingRevenueByRepActivatedReport = 6519,
    ViewUpsellProductByRepReport = 6520,
    ViewUpsellRevenueByProductReport = 6521,
    ViewUpsellRevenueByProductOneTimeReport = 6522,
    ViewUpsellRevenueByRepReport = 6523,
    ViewUpsellRevenueByRepOneTimeReport = 6524,
    ViewWeeklyRevenueReport = 6525,
    ViewWeeklySalesChartReport = 6526,
    ViewWeeklySalesChartAverageReport = 6527,
    ViewWeeklySalesChartAverageDcsOnlyReport = 6528,
    ViewWeeklySalesChartAverageLacReport = 6529,
    ViewWeeklySalesChartAverageTextingReport = 6530,
    ViewWeeklySalesChartSoldReport = 6531,
    ViewYearEndTotalsReport = 6532,
    ViewYearEndTotalsGrowthReport = 6533,
    ViewAllProductRevenueReport = 6534,
    ViewAllRevenueByMonthSummaryReport = 6535,
    ViewAllRevenueByRepReport = 6536,
    ViewAllSalesByMonthSummaryReport = 6537,
    ViewProductsInCancellationRequestReport = 6538,
    ViewRevenueByProductReport = 6539,
    ViewRevenueByRateReport = 6540,
    ViewCaseCountReport = 6541,
    ViewCaseNetReport = 6542,
    ViewClosedCasesReport = 6543,
    ViewClosedCasesByReasonReport = 6544,
    ViewClosedCasesByUserReport = 6545,
    ViewClosedDataTeamCasesReport = 6546,
    ViewClosedIntroCasesReport = 6547,
    ViewClosedSupportCasesReport = 6548,
    ViewCreatedCasesStillOpenReport = 6549,
    ViewOpenCasesReport = 6550,
    ViewOpenedSupportCasesReport = 6551,
    ViewOpenIntroCasesReport = 6552,
    ViewOutboundCallHistoryReport = 6553,
    ViewOutboundCallHistoryByUserReport = 6554,
    ViewTvCasesClosedReport = 6555,
    ViewTvDealersSavedThisMonthReport = 6556,
    ViewTvDealersSavedThisWeekReport = 6557,
    ViewTvDealersSavedTodayReport = 6558,
    ViewTvlacRevenueByRepActivatedReport = 6559,
    ViewTvOutboundCallHistoryCsReport = 6560,
    ViewTvOutboundCallHistoryLacSalesReport = 6561,
    ViewTvOutboundCallHistoryRetentionReport = 6562,
    ViewTvOutboundCallHistorySalesReport = 6563,
    ViewTvOutboundCallHistoryTextingSalesReport = 6564,
    ViewTvRevenueByRepActivatedReport = 6565,
    ViewTvRevenueSoldCancelledNetGrowthReport = 6566,
    ViewTvRevenueSummaryReport = 6567,
    ViewTvSalesSummaryReport = 6568,
    ViewTvTextingRevenueByRepActivatedReport = 6569,
    ViewTvWebTeamPointsReport = 6570,
    ViewTvWebTeamWebsiteChangesReport = 6571,
    ViewTvWebTeamWebsitesBuildReport = 6572,
    ViewEchosignTab = 6573,
    EditSmsWelcomeMessage = 6574,
    PullPayment = 6575,
    ViewInitialRecurringPaymentInfoOnSignup = 6576,
    ChangeDealerProductSalesPerson = 6577,
    ViewCarGurusVdpViewsReport = 6578,
    ViewCarGurusInteractionsReport = 6579,
    AddDrivingSalesReview = 6580,
    EditDrivingSalesReview = 6581,
    DeleteDrivingSalesReview = 6582,
    VerifyDrivingSalesReview = 6583,
    SignUpCrmDealer = 6586,
    EditSignUpCrmDealer = 6587,
    ViewAllEmailConversations = 6588,
    ViewDeletedLeads = 6589,
    UnDeleteDcsLead = 6590,
    SixMonthListingAllCarsPromoExistingAch = 6591,
    SixMonthListingAllCarsPromoExistingByMail = 6592,
    SixMonthListingAllCarsPromoExistingCc = 6593,
    ViewEbayDealersReport = 6594,
    SignUpEbayDealer = 6595,
    EditSignUpEbayDealer = 6596,
    EditWebsiteScssVariable = 6597,
    EditWebsiteTemplateScssVariable = 6598,
    ViewSwaggerUi = 6599,
    MergeLeads = 6611,
    EditCustomView = 6612,
    UpdateInventorySEO = 6613,
    UpdateCampaignRadiusBudget = 6614,
    CancelFacebook = 6615,
    ChangeLogo = 6616,
    ChangeWebsiteStyle = 6617,
    ChangeModuleStyle = 6618,
    ChangePrimaryColor = 6619,
    ChangePageSEO = 6620,
    EditInventoryDefaultValues = 6621,
    CanPlayCallTrackingRecordings = 6622,
    ViewAllFacebookConversations = 6623,
    AddTwilioFacebook = 6624,
    EditTwilioFacebook = 6625,
    ReCreateCases = 6626,
    ReAssignMultipleLeads = 6627,
    ApproveTestimonial = 6628,
    ArchiveTextConversation = 6629,
    ArchiveFBConversation = 6630,
    GroupBulkMoveVehicles = 6631,
    DCSEditImports = 6632,
    ChangeOrderEditOwner = 6633,
    ViewArchivedTextConversations = 6634,
    ViewArchivedFBConversations = 6635,
    DeleteInventoryPrice = 6637,
    AddInventoryPrice = 6638,
    EditInventoryPriceOrder = 6639,
    EditOtherPeoplesReminders = 6640,
    ViewSoldInventory = 6641,
    DeletePriceDropNotification = 6642,
    BuyMonroneyLabel = 6645,
    DeleteMonroneyLabel = 6646,
    ViewMonroneyLabel = 6647,
    ArchiveEmailConversation = 6649,
    ViewArchivedEmailConversations = 6650,
    AddInventoryLink = 6651,
    EditInventoryLink = 6652,
    DeleteInventoryLink = 6653,
    AddMessageTemplate = 6654,
    EditMessageTemplate = 6655,
    DeleteMessageTemplate = 6656,
    AddAudioEye = 6657,
    EditAudioEye = 6658,
    DeleteAudioEye = 6659,
    AddLeadStatus = 6601,
    EditLeadStatus = 6602,
    DeleteLeadStatus = 6603,
    ViewLeadDocument = 6660,
    AddLeadDocument = 6661,
    DeleteLeadDocument = 6662,
    EditLeadDocument = 6663,

    AddMerchant = 6690,
    EditMerchant = 6691,
    DeleteMerchant = 6692,

    AddSpamFilter = 6694,
    EditSpamFilter = 6695,
    DeleteSpamFilter = 6696,
    ApproveCase = 6705,
    ViewRetentionCasesView = 6672,
    ViewCSCasesView = 6673,
    ViewDataCasesView = 6674,
    ViewWebCasesView = 6675,
    ViewDomainCasesView = 6676,
    ViewDBAccessCasesView = 6677,
    ViewSEOCasesView = 6678,
    ViewSalesCasesView = 6679,
    ViewQACasesView = 6707,
    ViewAccountingCasesView = 6708,
    ViewFrazerOneCasesView = 6723
}

// global redux state types
export interface IUserState {
    authenticated: boolean,
    userId: number,
    roleId: number,
    token: string,
    permissions: Array<number>,
    authErrors: Array<string>,
    multiFactorConfirmed: boolean,
    multiFactorLoginEnabled: boolean,
    //short term mfa token used for things such updating password, mfa, etc.
    multiFactorGuid: string,
    multiFactorGuidExpireDate: Date,
    homePage: string,
}

export interface IAppState {
    loading: boolean,
    loaded: boolean,
    locationHistory: Array<Location>
    routes: Array<MenuRouteDto> | undefined
}

export interface IRootState {
    app: IAppState,
    user: IUserState
}

export interface IJwtToken {
    uid: string,
    roleid: string,
    did: string,
    dgid: string,
}

export interface IPagedData<T> {
    loaded: boolean,
    items: Array<T>,
    page: number,
    pageSize: number,
    skip: number,
    totalItems?: number,
    errors: Array<string>
}

export interface IPagedDataWithTotals<T1, T2> {
    loaded: boolean,
    items: Array<T1>,
    totals: T2,
    page: number,
    pageSize: number,
    skip: number,
    totalItems?: number,
    errors: Array<string>
}

export interface INotPagedData<T> {
    loaded: boolean,
    items: Array<T>,
    totalItems?: number,
    errors: Array<string>
}

export interface IPageProps {
    title: string
}

export type IParamsType = Record<string, string | undefined>;

export interface IParamsId extends IParamsType {
    id: string
}

export interface AlertMessage {
    variant: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light'
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    messages: Array<string> | Array<ReactElement<any>>
}

export enum GridCellEnum {
    YesNoBoolean,       // Display a yes or no for a boolean value
    DeleteAction,       // Display a delete icon wired to a confirm modal  
    Concatenate,        // Display first fifty characters then '...'
    MultiDelete,        // Display checkbox for user to select row(s) to delete
    MultiSelect,        // Display checkbox for users to select row(s) to update
    ChildSort,          // Display the value correctly when field name setup as a child sort with dot notation
    HTML,               // Display text as HTML
    DropDown,
    ConcatHTML,         // Removes text from html string and concats to 50 characters + ...
    Currency,       // Display currency edit
    Boolean
}

export interface ICustomColumn {
    title?: string
    field?: string
    minGridWidth?: number
    maxGridWidth?: number
    sortable?: boolean
    cell?: ComponentType<GridCellProps>
    cellType?: GridCellEnum
    headerCell?: ComponentType<GridHeaderCellProps>
    filter?: string
    width?: string
    format?: string
    className?: string
    headerClassName?: string
    display?: boolean
    editable?: boolean
    orderIndex?: number | undefined;
    editor?: 'text' | 'numeric' | 'boolean' | 'date',
    filterable?: boolean
    filterType?: 'text' | 'numeric' | 'boolean' | 'date'
    filterCell?: ComponentType<GridFilterCellProps>,
    footerCell?: ComponentType<GridFooterCellProps>
}

export enum FormTypeEnum {
    Add,
    Edit,
    Copy,
    Default
}

export interface IDropDownValue {
    id: number,
    text: string
}

export interface IDealerChangedEvent {
    dealerId: number | undefined
    name: string | undefined
}

export enum GridItemDeleteEnum {
    CanBeDeleted,
    CantBeDeletedDefaultRecord,
    CantBeDeletedInUse,
    CantBeDeletedPermission
}

export interface IGridLocalStorageNames {
    sort: string
    search: string
    selectedPage: string
    pageSize: string
}
export interface IDateSearchLocalStorageNames {
    startDate: string
    endDate: string
    relativeDateOption: string
}

export enum TypeEnum {
    caseStatus,
    caseSubStatus,
    caseType,
    caseReason,
    caseSubReason,
    casePriority,
    caseOrigin,
    activeUser,
    allUsers,
    dealerContact,
    competitor,
    cancellationReason,
    approveCaseUser
}

export interface IMultiSelect {
    id: number,
    selected: boolean
    onCurrentPage: boolean
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any
}
